module.exports = __webpack_public_path__ + "static/media/policeCar_pink.153623de.svg";